"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FBTAddToCart = FBTAddToCart;
exports.addItemsToCart = addItemsToCart;
exports.addToCart = addToCart;
exports.addToCartV2 = addToCartV2;
exports.asterOnlineAddToCart = asterOnlineAddToCart;
exports.cartProductsRecommendation = cartProductsRecommendation;
exports.createRxCart = void 0;
exports.deleteProducts = deleteProducts;
exports.deleteProductsV2 = deleteProductsV2;
exports.getCartDetails = void 0;
exports.getCartFillers = getCartFillers;
exports.getCartInfo = getCartInfo;
exports.getCartInfoV2 = getCartInfoV2;
exports.getCartMarketingBanners = getCartMarketingBanners;
exports.getCommonCartAPI = getCommonCartAPI;
exports.getTopSellingProducts = getTopSellingProducts;
exports.mergeCartDetails = void 0;
exports.removeItemFromCart = removeItemFromCart;
exports.removeMultipleItemsFromCart = removeMultipleItemsFromCart;
exports.updateItemsInCart = updateItemsInCart;
exports.updateProductQuantity = updateProductQuantity;
exports.updateProductQuantityV2 = updateProductQuantityV2;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function addToCart(requestParams, tokenData) {
  var _requestParams$data;
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.ADD_TO_CART;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams === null || requestParams === void 0 || (_requestParams$data = requestParams.data) === null || _requestParams$data === void 0 ? void 0 : _requestParams$data.params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.POST,
  //   apiPostData: requestParams?.data?.params || {}
  // });
}
function updateProductQuantity(requestParams, tokenData) {
  var _requestParams$data2;
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.UPDATE_ITEM_QUANTITY_CART;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams === null || requestParams === void 0 || (_requestParams$data2 = requestParams.data) === null || _requestParams$data2 === void 0 ? void 0 : _requestParams$data2.params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.PUT,
  //   apiPostData: requestParams?.data?.params || {}
  // });
}
function getCartInfo(param, tokenData) {
  const queryString = (0, _utils.getQuery)(param);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_CART_INFO + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getTopSellingProducts(params, tokenData) {
  const queryString = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.TOP_SELLING_PRODUCT + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function deleteProducts(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.DELETE_ITEMS;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.DELETE, apiPostData: params });
}
function cartProductsRecommendation(pageSize, pageFrom, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.CART_PRODUCTS_RECOMMENDATION + `?pageSize=${pageSize}&pageFrom=${pageFrom}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function addToCartV2(requestParams, tokenData) {
  var _requestParams$data3;
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.ADD_TO_CART_V2;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams === null || requestParams === void 0 || (_requestParams$data3 = requestParams.data) === null || _requestParams$data3 === void 0 ? void 0 : _requestParams$data3.params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.POST,
  //   apiPostData: requestParams?.data?.params || {}
  // });
}
function updateProductQuantityV2(requestParams, tokenData) {
  var _requestParams$data4;
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.UPDATE_ITEM_QUANTITY_CART_V2;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams === null || requestParams === void 0 || (_requestParams$data4 = requestParams.data) === null || _requestParams$data4 === void 0 ? void 0 : _requestParams$data4.params;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.PUT,
  //   apiPostData: requestParams?.data?.params || {}
  // });
}
function deleteProductsV2(params, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.DELETE_ITEMS_V2;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.DELETE, apiPostData: params });
}
function getCartInfoV2(param, tokenData) {
  const queryString = (0, _utils.getQuery)(param);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.GET_CART_INFO_V2 + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function FBTAddToCart(params, tokenData) {
  const apiEndPoint = _ApiConst.FBT_ADD_TO_CART;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCartMarketingBanners(tokenData) {
  const apiEndPoint = _ApiConst.CMS_COMMON_FOOTER_API + 'AE_CART_BANNERS_1/details';
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCartFillers(params, tokenData) {
  const {
    ...rest
  } = params || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CART_FILLERS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function asterOnlineAddToCart(params, tokenData) {
  const apiEndPoint = _ApiConst.ASTER_ONLINE_ADD_TO_CART;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}

/**
 * New Cart Api which provides merge response of CartInfo and CartInfoDetail
 * **/

function getCommonCartAPI(tokenData, requestParams = {}) {
  const {
    userId,
    ...rest
  } = requestParams || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_CART_INFO}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}

/* New cart api's */

const getCartDetails = (requestParams = {}, tokenData) => {
  const {
    userId = '',
    cartId,
    ...rest
  } = requestParams || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.GET_CART_DETAILS)(cartId)}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getCartDetails = getCartDetails;
const createRxCart = (requestParams = {}, tokenData) => {
  const {
    userId = '',
    zones = [],
    skus = [],
    cartId = '',
    ...rest
  } = requestParams || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.CREATE_RX_CART}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = {
    zones,
    skus,
    cart_id: cartId
  };
  options.method = _ApiConst.API_PARAMS.POST;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.createRxCart = createRxCart;
function addItemsToCart(requestParams, tokenData) {
  var _requestParams$data5;
  const {
    userId = '',
    zones,
    cartType = '',
    items,
    ...rest
  } = (requestParams === null || requestParams === void 0 || (_requestParams$data5 = requestParams.data) === null || _requestParams$data5 === void 0 ? void 0 : _requestParams$data5.params) || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.ADD_ITEMS_TO_CART}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = {
    user_id: userId,
    zones,
    cart_type: cartType,
    items
  };
  options.method = _ApiConst.API_PARAMS.POST;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function updateItemsInCart(params, tokenData) {
  var _params$data;
  const {
    userId = '',
    zones,
    cartId = '',
    sku,
    quantity,
    ...rest
  } = (params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.params) || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.UPDATE_ITEMS_IN_CART)(cartId)}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = {
    sku,
    user_id: userId,
    zones,
    quantity
  };
  options.method = _ApiConst.API_PARAMS.PUT;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function removeItemFromCart(params, tokenData) {
  var _params$data2;
  const {
    userId = '',
    cartId = '',
    sku = '',
    ...rest
  } = (params === null || params === void 0 || (_params$data2 = params.data) === null || _params$data2 === void 0 ? void 0 : _params$data2.params) || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.REMOVE_ITEM_FROM_CART)({
    cartId,
    sku
  })}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = rest;
  options.method = _ApiConst.API_PARAMS.DELETE;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function removeMultipleItemsFromCart(params, tokenData) {
  var _params$data3;
  const {
    userId = '',
    cartId = '',
    ...rest
  } = (params === null || params === void 0 || (_params$data3 = params.data) === null || _params$data3 === void 0 ? void 0 : _params$data3.params) || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.REMOVE_MULTIPLE_ITEMS_FROM_CART)({
    cartId
  })}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
const mergeCartDetails = (requestParams = {}, tokenData) => {
  const {
    userId = '',
    ...rest
  } = requestParams || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.MERGE_CART_DETAILS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.PUT;
  // genericFetch({ apiEndPoint, options: {...options, 'x-vcp-user-id': '6232'} })
  return (0, _genericFetch.default)({
    apiEndPoint,
    options: {
      ...options,
      headers: {
        ...(options === null || options === void 0 ? void 0 : options.headers),
        'x-user-vcpId': userId
      }
    }
  });
};
exports.mergeCartDetails = mergeCartDetails;